<template>
  <Header/>
  <div class="container-fluid balansir-page">
    <div class="row">
      <div class="col-4 balansir-list">
        <input v-model="search" type="text" class="form-control" placeholder="Поиск: имя, фраза, адрес трекера"/>
        <div class="btn-bar">
          <button class="btn btn-sm btn-primary" @click="newRecord">+ Новая</button>
          <button class="btn btn-sm btn-outline-secondary" @click="showMass = true" :disabled="!records.length">Массовая замена</button>
          <button class="btn btn-sm btn-outline-secondary" @click="showVersions = true">Версии</button>
          <button class="btn btn-sm btn-success" @click="publish" :disabled="publishing">
            {{ publishing ? 'Публикуем…' : 'Опубликовать всё' }}
          </button>
        </div>
        <div v-if="publishResult" class="publish-result" :class="publishResult.ok ? 'text-success' : 'text-danger'">
          {{ publishResult.text }}
        </div>
        <div v-for="grp in groupedRecords" :key="grp.name" class="name-group">
          <div class="group-title" @click="toggleGroup(grp.name)">
            {{ opened[grp.name] ? '▼' : '▶' }} {{ grp.name }} ({{ grp.records.length }})
          </div>
          <div v-if="opened[grp.name]">
            <div v-for="r in grp.records" :key="r.groupId" class="rec-row"
                 :class="{ active: current && current.groupId === r.groupId }">
              <input type="checkbox" :value="r.groupId" v-model="selected"/>
              <span class="rec-label" @click="selectRecord(r)">
                {{ r.utm.join(', ') || '(без фраз)' }}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="col-8">
        <BalansirEditor v-if="current"
          :record="current" :isNew="isNew"
          :trackerOptions="trackerOptions" :allRecords="records"
          @saved="onSaved" @deleted="onDeleted" @duplicate="onDuplicate"/>
        <div v-else class="text-muted" style="padding-top: 2em">
          Выберите запись слева или создайте новую.
        </div>
      </div>
    </div>
    <BalansirMassModal v-if="showMass"
      :records="records" :selectedIds="selected" :trackerOptions="trackerOptions"
      @close="showMass = false" @done="load"/>
    <BalansirVersionsModal v-if="showVersions"
      @close="showVersions = false" @restored="onRestored"/>
  </div>
</template>

<script>
import axios from "axios";
import Header from '@/components/Header.vue';
import BalansirEditor from '@/components/balansir/BalansirEditor.vue';
import BalansirMassModal from '@/components/balansir/BalansirMassModal.vue';
import BalansirVersionsModal from '@/components/balansir/BalansirVersionsModal.vue';

const TRACKER_HOST = 'https://trends-ds.com/tracker/';

export default {
  components: {
    Header,
    BalansirEditor,
    BalansirMassModal,
    BalansirVersionsModal,
  },
  data() {
    return {
      records: [],
      selected: [],
      current: null,
      isNew: false,
      search: '',
      opened: {},
      trackerOptions: [],
      showMass: false,
      showVersions: false,
      publishing: false,
      publishResult: null,
      hostApi: process.env.VUE_APP_API_URL ? process.env.VUE_APP_API_URL : 'http://localhost:5001',
    };
  },
  computed: {
    groupedRecords() {
      const q = this.search.trim().toLowerCase();
      const filtered = this.records.filter(r => {
        if (!q) return true;
        return (r.name || '').toLowerCase().includes(q)
          || r.utm.some(u => (u || '').toLowerCase().includes(q))
          || (r.urlA || '').toLowerCase().includes(q)
          || (r.urlB || '').toLowerCase().includes(q);
      });
      const map = {};
      for (const r of filtered) {
        const name = r.name || '(без имени)';
        if (!map[name]) map[name] = [];
        map[name].push(r);
      }
      return Object.keys(map).sort().map(name => ({ name: name, records: map[name] }));
    },
  },
  mounted() {
    axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('token')}`;
    this.load();
    this.loadTrackers();
  },
  methods: {
    load() {
      let vm = this;
      axios.post(vm.hostApi + '/api/v1/balansir/get', {})
        .then(function (response) {
          vm.records = response.data.data || [];
          vm.selected = vm.selected.filter(id => vm.records.some(r => r.groupId === id));
        })
        .catch(function (error) { console.log(error); alert('Ошибка загрузки записей'); });
    },
    loadTrackers() {
      let vm = this;
      axios.post(vm.hostApi + '/api/v1/project/get', { clientId: localStorage.getItem('clientId') })
        .then(function (response) {
          const projects = response.data.data || [];
          projects.forEach(p => {
            axios.post(vm.hostApi + '/api/v1/token/get', { projectId: p.id })
              .then(function (resp) {
                const tokens = (resp.data || []).filter(t => t.deleted !== true);
                tokens.forEach(t => {
                  vm.trackerOptions.push({
                    label: p.name + ' / ' + (t.name || t.token),
                    url: TRACKER_HOST + 'tracker_' + t.token + '.js',
                  });
                });
              })
              .catch(function (error) { console.log(error); });
          });
        })
        .catch(function (error) { console.log(error); });
    },
    toggleGroup(name) {
      this.opened[name] = !this.opened[name];
    },
    selectRecord(r) {
      this.isNew = false;
      this.current = JSON.parse(JSON.stringify(r));
    },
    newRecord() {
      this.isNew = true;
      this.current = {
        groupId: '', name: '', landingUrl: '', utm: [],
        urlA: '', urlB: '', blockReWriteA: [], blockReWriteB: [],
      };
    },
    publish() {
      if (!window.confirm('Опубликовать текущие данные в балансировщик (обновить Redis)?')) return;
      let vm = this;
      vm.publishing = true;
      vm.publishResult = null;
      axios.post(vm.hostApi + '/api/v1/balansir/publish', {})
        .then(function (response) {
          const d = response.data.data;
          vm.publishResult = { ok: d.ok, text: d.ok ? 'Опубликовано: ' + d.body : 'Ошибка ' + d.status + ': ' + d.body };
        })
        .catch(function (error) {
          console.log(error);
          vm.publishResult = { ok: false, text: 'Ошибка: ' + (error.response && error.response.data && error.response.data.message ? error.response.data.message : error.message) };
        })
        .finally(function () { vm.publishing = false; });
    },
    onSaved(groupId) {
      this.load();
      this.isNew = false;
      if (this.current) this.current.groupId = groupId;
    },
    onDeleted() {
      this.current = null;
      this.load();
    },
    onDuplicate(copy) {
      this.isNew = true;
      this.current = copy;
    },
    onRestored() {
      this.current = null;
      this.selected = [];
      this.load();
    },
  },
};
</script>

<style scoped>
.balansir-page { text-align: left; padding-top: 1em; }
.balansir-list { border-right: 1px solid #ddd; max-height: 85vh; overflow-y: auto; }
.btn-bar { margin: 0.5em 0; display: flex; gap: 0.4em; flex-wrap: wrap; }
.name-group { margin-bottom: 0.3em; }
.group-title { cursor: pointer; font-weight: bold; padding: 0.2em 0; }
.rec-row { padding: 0.15em 0 0.15em 1.2em; display: flex; gap: 0.4em; align-items: baseline; }
.rec-row.active { background: var(--accent-soft); }
.rec-label { cursor: pointer; }
.publish-result { font-size: 0.9em; margin-bottom: 0.5em; }
</style>
